import * as ng from '@angular/core';
import * as Rx from 'rxjs';
import {Player, PlayerStatus} from "./player";
import {buildQuery} from "../query";
import {map} from "rxjs/operators";

export class PlayerNative implements Player {

  private _playListURL: string;

  status: PlayerStatus = "unloaded";

  private play$: Rx.Subscription;
  private onLoad;
  private onError;

  constructor(
    private video: ng.ElementRef<HTMLVideoElement>
  ) {
    if (!this.video.nativeElement.canPlayType('application/vnd.apple.mpegurl')) {
      console.warn("This device cannot play HLS on native!")
    }
    // Native MacOS/iOS Safari player cannot recover autoplay state.
    window.addEventListener('focus', function () {
      window.location.reload();
    })
  }

  canPause(): boolean {
    return this.status === 'played';
  }

  pause(force: boolean): boolean {
    if (!this.canPause() && !force) {
      return false;
    }

    if (this.play$ !== undefined) {
      this.play$.unsubscribe();
      this.play$ = undefined;
    }
    this.video.nativeElement.muted = true;
    this.video.nativeElement.src = "";
    this.video.nativeElement.pause();
    return true;
  }

  play(playListURL: string, query: { [_: string]: string } | undefined, forceReset: boolean = false) {
    if (this._playListURL === playListURL && !forceReset) {
      return;
    }
    if (!this.video) {
      return;
    }
    // TODO iOS Safari の場合にだけ付与する
    // query['player'] = "avkit";

    this._playListURL = playListURL;

    this.status = "loading";
    // MEMO: https://stackoverflow.com/a/50742427
    this.video.nativeElement.muted = true;
    this.video.nativeElement.src = playListURL;

    this.onLoad = () => this.executePlay();
    this.onError = (e: Event) => {
      this.status = "cannot_view";
      console.log(e);
    };
    this.video.nativeElement.addEventListener('loadedmetadata', this.onLoad);
    this.video.nativeElement.play();
    this.video.nativeElement.addEventListener('error', this.onError);
  }

  private executePlay() {
    if (this.play$ !== undefined) {
      this.play$.unsubscribe();
      this.play$ = undefined;
    }

    let playAsync = this.video.nativeElement.play();

    if (playAsync === undefined) {
      // "video.play" on IE 11 returns undefined.
      playAsync = Promise.resolve()
    }

    // MEMO: https://stackoverflow.com/a/50742427
    if (this.video) {
      this.video.nativeElement.muted = true;
    }

    this.play$ = Rx.from(playAsync).pipe(
      map(() => {
        this.status = 'played'
      })
    ).subscribe();
  }

  stopLoading(): boolean {
    if (this.play$ !== undefined) {
      this.play$.unsubscribe();
      this.play$ = undefined;
    }

    this.status = "unloaded";
    // TODO Native player の loading を止める方法が不明 (pause だけ呼ぶ)
    return this.pause(false);
  }

  destroy() {
    if (this.video) {
      this.video.nativeElement.muted = true;
      this.video.nativeElement.src = "";
    }

    this.stopLoading();

    if (this.video) {
      this.video.nativeElement.removeEventListener('loadedmetadata', this.onLoad);
      this.video.nativeElement.removeEventListener('error', this.onError);
    }

  }
}
